import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';

import { useExamples } from '../../hooks/useSwr';

export function PublicExampleCrumb(props: Partial<BreadcrumbData>) {
  const { datasetShareToken, exampleId } = useParams();
  const example = useExamples(exampleId ? { id: [exampleId] } : null, {
    datasetShareToken,
  });
  return (
    <Breadcrumb
      name={example.data?.[0].name ? `Example: ${example.data?.[0].name}` : ''}
      {...props}
    />
  );
}
